import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, capitalize, Menu, MenuItem, styled } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Disabler } from './disabler';
export const PentairFilterSelect = (props) => {
    const { options, value, onChange, disabled, title, placeholder } = props;
    const anchorRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const toggleMenu = (event) => {
        setAnchorEl((el) => (el ? null : event.currentTarget));
    };
    const handleChange = useCallback((newValue) => {
        if (onChange && newValue !== value) {
            onChange(newValue);
        }
        setAnchorEl(null);
    }, [onChange, value]);
    useEffect(() => {
        const hasOptions = options && options.length > 0;
        const valueExists = options?.find((v) => v.value === value);
        const isSingleOption = options?.length === 1;
        if (!disabled && onChange) {
            if (!valueExists && isSingleOption) {
                onChange(options?.[0].value);
            }
            if (!hasOptions && !valueExists && !isSingleOption) {
                // console.log(title, 'here', disabled);
                onChange?.('');
            }
        }
        // only run when options change
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options, disabled]);
    return (_jsxs(Disabler, { disabled: disabled || !options?.length ? true : false, sx: { whiteSpace: 'nowrap' }, children: [_jsxs(FilterButton, { id: title.toLowerCase().replaceAll(' ', '-') + '-filter-button', "aria-controls": open ? 'select ' + title : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, ref: anchorRef, onClick: toggleMenu, children: [title, ":", ' ', _jsx("strong", { children: options?.find((v) => v.value === value)?.label ||
                            (!options?.length && 'N/A') ||
                            value?.toString() ||
                            placeholder })] }), _jsx(Menu, { anchorEl: anchorEl, open: open, onClose: toggleMenu, children: options?.map((option) => (_jsx(MenuItem, { onClick: () => handleChange(option.value), selected: option.value === value, children: option.label || option.valueLabel || capitalize(option.value) }, option.value))) })] }));
};
export default PentairFilterSelect;
export const FilterButton = styled(Button)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.paper,
    fontWeight: 'normal',
    color: theme.palette.silverGray.main,
    '& strong': {
        marginLeft: 8,
    },
    '& strong, & .MuiButton-endIcon': {
        color: theme.palette.secondary.main,
        fontWeight: '600',
    },
}));
FilterButton.defaultProps = {
    disableRipple: true,
    disableTouchRipple: true,
    endIcon: _jsx(FontAwesomeIcon, { style: { fontSize: '13px' }, icon: faAngleDown }),
    variant: 'text',
};
